// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SliderHomepage_outerDiv__c-y9p {
    margin: auto;
    max-width: 95%;
    padding-bottom: 0rem;
  }
  
  .SliderHomepage_header__70eXf {
    color: white;
    padding-bottom: 0rem;
    font-size: 20px;
    font-weight: bold;
  }
  
  .SliderHomepage_slide__Lqn-a {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    height: auto;
    max-height: 350px;
    transition: transform 0.3s ease-in-out; /* Smooth transition for zoom effect */
    cursor: pointer;
  }
  
  .SliderHomepage_slide__Lqn-a img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensures the image covers the div without distortion */
    border-radius: 5px;
    transition: transform 0.3s ease-in-out; /* Smooth transition */
    min-height: 229px;
  }
  
  /* Zoom-up effect on hover */

  
  
  
  /* Play icon styling */
  .SliderHomepage_playIcon__yCf\\+m {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    border-radius: 50%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }
  
 
  
  .SliderHomepage_deleteIcon__VQ5VO {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    z-index: 10;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .SliderHomepage_slide__Lqn-a:hover .SliderHomepage_deleteIcon__VQ5VO {
    opacity: 1;
  }
  
  .SliderHomepage_progressBarContainer__y\\+yEA {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.3);
  }
  
  .SliderHomepage_progressBar__oKWCr {
    height: 100%;
    background-color: #e50914;
  }
  
  .SliderHomepage_itemTitle__O5iq9 {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    color: white;
    font-size: 14px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  /* Tablets - 768px and below */
  @media screen and (max-width: 768px) {
    .SliderHomepage_header__70eXf {
      font-size: 20px;
    }
    
    .SliderHomepage_slide__Lqn-a {
      height: auto;
      max-height: 350px;
      min-height: 230px;
    }
    
    .SliderHomepage_playIcon__yCf\\+m {
      padding: 8px;
    }
    
    .SliderHomepage_deleteIcon__VQ5VO {
      padding: 4px;
    }
    
    .SliderHomepage_itemTitle__O5iq9 {
      font-size: 12px;
      bottom: 8px;
      left: 8px;
      right: 8px;
    }
    
    .SliderHomepage_progressBarContainer__y\\+yEA {
      height: 3px;
    }
    .SliderHomepage_slide__Lqn-a img {
      min-height: 230px;
    }
  }
  
  /* Mobile (showing 3 slides) - 500px and below */
  @media screen and (max-width: 500px) {
    .SliderHomepage_outerDiv__c-y9p {
      max-width: 100%;
      padding-bottom: 5px;
    }
    .SliderHomepage_slide__Lqn-a img{
      height: 180px;
      min-height: 150px;
    }

    
    .SliderHomepage_header__70eXf {
      font-size: 18px;
      padding-bottom: 0rem;
    }
    
    .SliderHomepage_slide__Lqn-a {
      height: 180px;
      min-height: 175px;
  
    }
    
    .SliderHomepage_playIcon__yCf\\+m {
      padding: 6px;
    }
    
    .SliderHomepage_deleteIcon__VQ5VO {
      top: 5px;
      right: 5px;
      padding: 3px;
    }
    
    .SliderHomepage_itemTitle__O5iq9 {
      font-size: 10px;
      bottom: 6px;
      left: 6px;
      right: 6px;
    }
    
    .SliderHomepage_progressBarContainer__y\\+yEA {
      height: 2px;
    }
  }
  
  /* Mobile L - 425px and below */
  @media screen and (max-width: 425px) {
    .SliderHomepage_slide__Lqn-a {
      height: auto;
      max-height: 200px;
      min-height: 130px;
    }
    
    .SliderHomepage_header__70eXf {
      font-size: 18px;
    }
    
    .SliderHomepage_playIcon__yCf\\+m {
      padding: 5px;
    }
    
    .SliderHomepage_itemTitle__O5iq9 {
      font-size: 9px;
      bottom: 5px;
      left: 5px;
      right: 5px;
    }
  }
  
  /* Mobile S - 320px and below */
  @media screen and (max-width: 320px) {
    .SliderHomepage_slide__Lqn-a {
      height: auto;
      max-height: 150px;
      min-height: 100px;
    }
    
    .SliderHomepage_playIcon__yCf\\+m {
      padding: 4px;
    }
    
    .SliderHomepage_deleteIcon__VQ5VO {
      top: 3px;
      right: 3px;
      padding: 2px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/SliderHomepage.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,sCAAsC,EAAE,sCAAsC;IAC9E,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wDAAwD;IAC3E,kBAAkB;IAClB,sCAAsC,EAAE,sBAAsB;IAC9D,iBAAiB;EACnB;;EAEA,4BAA4B;;;;;EAK5B,sBAAsB;EACtB;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,8BAA8B,EAAE,gCAAgC;IAChE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;EACxC;;;;EAIA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,WAAW;MACX,SAAS;MACT,UAAU;IACZ;;IAEA;MACE,WAAW;IACb;IACA;MACE,iBAAiB;IACnB;EACF;;EAEA,gDAAgD;EAChD;IACE;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,iBAAiB;IACnB;;;IAGA;MACE,eAAe;MACf,oBAAoB;IACtB;;IAEA;MACE,aAAa;MACb,iBAAiB;;IAEnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,QAAQ;MACR,UAAU;MACV,YAAY;IACd;;IAEA;MACE,eAAe;MACf,WAAW;MACX,SAAS;MACT,UAAU;IACZ;;IAEA;MACE,WAAW;IACb;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,YAAY;MACZ,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,cAAc;MACd,WAAW;MACX,SAAS;MACT,UAAU;IACZ;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,YAAY;MACZ,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,QAAQ;MACR,UAAU;MACV,YAAY;IACd;EACF","sourcesContent":[".outerDiv {\n    margin: auto;\n    max-width: 95%;\n    padding-bottom: 0rem;\n  }\n  \n  .header {\n    color: white;\n    padding-bottom: 0rem;\n    font-size: 20px;\n    font-weight: bold;\n  }\n  \n  .slide {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    height: auto;\n    max-height: 350px;\n    transition: transform 0.3s ease-in-out; /* Smooth transition for zoom effect */\n    cursor: pointer;\n  }\n  \n  .slide img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; /* Ensures the image covers the div without distortion */\n    border-radius: 5px;\n    transition: transform 0.3s ease-in-out; /* Smooth transition */\n    min-height: 229px;\n  }\n  \n  /* Zoom-up effect on hover */\n\n  \n  \n  \n  /* Play icon styling */\n  .playIcon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    border-radius: 50%;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n \n  \n  .deleteIcon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: rgba(0, 0, 0, 0.6);\n    border-radius: 50%;\n    padding: 5px;\n    cursor: pointer;\n    z-index: 10;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  \n  .slide:hover .deleteIcon {\n    opacity: 1;\n  }\n  \n  .progressBarContainer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background-color: rgba(255, 255, 255, 0.3);\n  }\n  \n  .progressBar {\n    height: 100%;\n    background-color: #e50914;\n  }\n  \n  .itemTitle {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    color: white;\n    font-size: 14px;\n    font-weight: bold;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  /* Tablets - 768px and below */\n  @media screen and (max-width: 768px) {\n    .header {\n      font-size: 20px;\n    }\n    \n    .slide {\n      height: auto;\n      max-height: 350px;\n      min-height: 230px;\n    }\n    \n    .playIcon {\n      padding: 8px;\n    }\n    \n    .deleteIcon {\n      padding: 4px;\n    }\n    \n    .itemTitle {\n      font-size: 12px;\n      bottom: 8px;\n      left: 8px;\n      right: 8px;\n    }\n    \n    .progressBarContainer {\n      height: 3px;\n    }\n    .slide img {\n      min-height: 230px;\n    }\n  }\n  \n  /* Mobile (showing 3 slides) - 500px and below */\n  @media screen and (max-width: 500px) {\n    .outerDiv {\n      max-width: 100%;\n      padding-bottom: 5px;\n    }\n    .slide img{\n      height: 180px;\n      min-height: 150px;\n    }\n\n    \n    .header {\n      font-size: 18px;\n      padding-bottom: 0rem;\n    }\n    \n    .slide {\n      height: 180px;\n      min-height: 175px;\n  \n    }\n    \n    .playIcon {\n      padding: 6px;\n    }\n    \n    .deleteIcon {\n      top: 5px;\n      right: 5px;\n      padding: 3px;\n    }\n    \n    .itemTitle {\n      font-size: 10px;\n      bottom: 6px;\n      left: 6px;\n      right: 6px;\n    }\n    \n    .progressBarContainer {\n      height: 2px;\n    }\n  }\n  \n  /* Mobile L - 425px and below */\n  @media screen and (max-width: 425px) {\n    .slide {\n      height: auto;\n      max-height: 200px;\n      min-height: 130px;\n    }\n    \n    .header {\n      font-size: 18px;\n    }\n    \n    .playIcon {\n      padding: 5px;\n    }\n    \n    .itemTitle {\n      font-size: 9px;\n      bottom: 5px;\n      left: 5px;\n      right: 5px;\n    }\n  }\n  \n  /* Mobile S - 320px and below */\n  @media screen and (max-width: 320px) {\n    .slide {\n      height: auto;\n      max-height: 150px;\n      min-height: 100px;\n    }\n    \n    .playIcon {\n      padding: 4px;\n    }\n    \n    .deleteIcon {\n      top: 3px;\n      right: 3px;\n      padding: 2px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerDiv": `SliderHomepage_outerDiv__c-y9p`,
	"header": `SliderHomepage_header__70eXf`,
	"slide": `SliderHomepage_slide__Lqn-a`,
	"playIcon": `SliderHomepage_playIcon__yCf+m`,
	"deleteIcon": `SliderHomepage_deleteIcon__VQ5VO`,
	"progressBarContainer": `SliderHomepage_progressBarContainer__y+yEA`,
	"progressBar": `SliderHomepage_progressBar__oKWCr`,
	"itemTitle": `SliderHomepage_itemTitle__O5iq9`
};
export default ___CSS_LOADER_EXPORT___;
